<template>
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path :style="getColor()" class="cls-1" d="M23.3,7.31h21.43c2.96,0,5.36,2.54,5.36,5.67v28.37c0,3.13-2.4,5.67-5.36,5.67,0,3.13-2.4,5.67-5.36,5.67H17.95c-2.96,0-5.36-2.54-5.36-5.67h2.68c0,1.57,1.2,2.84,2.68,2.84h21.43c1.48,0,2.68-1.27,2.68-2.84V18.65c0-1.57-1.2-2.84-2.68-2.84H17.95c-1.48,0-2.68,1.27-2.68,2.84h-2.68c0-3.13,2.4-5.67,5.36-5.67h21.43c2.96,0,5.36,2.54,5.36,5.67v25.53c1.48,0,2.68-1.27,2.68-2.84V12.98c0-1.57-1.2-2.84-2.68-2.84H23.3c-1.48,0-2.68,1.27-2.68,2.84h-2.68c0-3.13,2.4-5.67,5.36-5.67Z"/>
    <path :style="getColor()" class="cls-1" d="M12.59,24.33v-1.42c0-.78,.6-1.42,1.34-1.42s1.34,.64,1.34,1.42v1.42h1.34c.74,0,1.34,.64,1.34,1.42s-.6,1.42-1.34,1.42h-5.36c-.74,0-1.34-.64-1.34-1.42s.6-1.42,1.34-1.42h1.34Zm0,8.51v-1.42c0-.78,.6-1.42,1.34-1.42s1.34,.64,1.34,1.42v1.42h1.34c.74,0,1.34,.64,1.34,1.42s-.6,1.42-1.34,1.42h-5.36c-.74,0-1.34-.64-1.34-1.42s.6-1.42,1.34-1.42h1.34Zm0,7.09v1.42h-1.34c-.74,0-1.34,.64-1.34,1.42s.6,1.42,1.34,1.42h5.36c.74,0,1.34-.64,1.34-1.42s-.6-1.42-1.34-1.42h-1.34v-1.42c0-.78-.6-1.42-1.34-1.42s-1.34,.64-1.34,1.42Z"/>
  </svg>
</template>

<script>
export default {
  name: 'iconAvaliacao',
  props:["color"],
  methods: {
    getColor(){
      return {
        'fill': this?.color ?? "#FFF" ,
      }
    }
  }
}
</script>

<style scoped>
#Layer_1{
  width: 40px;;
}
</style>